export default "__VITE_ASSET__UMVPzwaB__"